import React from 'react';

import { setSession } from '@utils/session';
import { getLinks } from 'cache';
import { useRouter } from 'next/router';
import { getCaptcha } from 'utils/captcha';
import { useAsyncHandler } from 'utils/hooks';

import Container from '@ui/Container';
import PageTitle from '@ui/PageTitle';

import useApi from '@components/api/useApi';
import useLogin from '@components/auth/hooks/useLogin';
import RecaptchaInfo from '@components/auth/RecaptchaInfo';
import RegisterForm from '@components/auth/RegisterForm';
import Social from '@components/auth/Social/Social';
import useCms from '@components/Cms/useCms';
import { useAnalytics } from '@components/Providers/AnalyticsContextProvider';
import useUser from '@components/User/useUser';

const RegisterPage = () => {
    const api = useApi();
    const cms = useCms();
    const router = useRouter();
    const { reloadUser } = useUser();
    const { logSignUp } = useAnalytics();

    const [handleRegister, registerLoading] = useAsyncHandler({
        handler: async userData => {
            const captcha = await getCaptcha('registration');
            const response = await api.post('/auth/register', { ...userData, captcha });
            setSession(response.token);
            logSignUp(userData?.socialProviderId);
            await reloadUser();
        },
        onSuccess: () => router.replace(getLinks('email')),
        defaultErrorMessage: cms[122],
    });

    const [handleSocialLogin, socialLoading] = useLogin();

    const loading = socialLoading || registerLoading;

    return (
        <Container maxWidth="sm" sx={{ p: 0 }}>
            <PageTitle>{cms[22]}</PageTitle>
            <RegisterForm onSubmit={handleRegister} loading={loading} isDobRequired />
            {!loading && <Social onLogin={handleSocialLogin} loading={loading} isRegisterPage />}
            <RecaptchaInfo />
        </Container>
    );
};

export default RegisterPage;
